module.exports = __webpack_public_path__ + "img/woman-silueta.ddfa0f95.png";